import { Injectable } from '@angular/core';
import L from "leaflet";
import 'leaflet-easybutton/src/easy-button';
import { BehaviorSubject } from 'rxjs';
import { MapSettings } from '../classes/map-settings';
import { MapShortcut } from '../classes/map-shortcut';
import { MapShortcutBars } from '../classes/map-shortcut-bars';
import { MAP_SETTINGS_KEY } from '../common/constants';
@Injectable({
  providedIn: 'root'
})
export class MapSettingsService {
  public mapSettings$: BehaviorSubject<MapSettings> = new BehaviorSubject<MapSettings>(this.loadMapSettings());
  constructor() { }

  public loadMapSettings(): MapSettings{
    const localStorageString = localStorage.getItem(MAP_SETTINGS_KEY);
    return localStorageString !== null ? JSON.parse(localStorageString) : new MapSettings();
  }

  public saveMapSettings(mapSettings: MapSettings): void{
    localStorage.setItem(MAP_SETTINGS_KEY, JSON.stringify(mapSettings));
    this.mapSettings$.next(mapSettings);
  }


  makeMapLegend(): L.Control{
    const legend = new L.Control({
      position: 'bottomright'
    });
    legend.onAdd = function (map) {
      const divElem = L.DomUtil.create('div', 'info legend');
      const legendIcons = [
        ["icon\-pickup", "Pickup"],
        ["icon\-parking", "Parking"],
        ["icon\-airplane-black", "Airplane"],
        ["icon\-locate-me", "Follow Me"],
        ["icon\-minus", "Zoom Out"],
        ["icon\-plus", "Zoom In"]
      ];
      legendIcons.forEach((item, i) => {
        divElem.innerHTML += '<div class="legendRows"><div class=\"' + legendIcons[i][0] + ' cvvCustomIcon\"><\/div><div class="legendRowText\">' + legendIcons[i][1] + '<\/div><\/div>';
      });
      return divElem;
    };
    return legend;

  }

  makeShortcutBars(type: string): L.Control.EasyBar{
	  const shortcutBars:MapShortcutBars = new MapShortcutBars();
	  let mapshortsbar: Array<L.Control.EasyButton> = [];
	  	shortcutBars[type].forEach((shortcut:MapShortcut) => {
			mapshortsbar.push(L.easyButton(`<i class="icon-${shortcut.name} mapShortcutFontIcons"></i>`, function (btn, map) {
				map.flyTo(shortcut.pos, 17);
			}));
		});
	  return L.easyBar(mapshortsbar);
  }

}
